import _ from "lodash";
import axios from "axios";

import IMeta from "models/IMeta";
import { setLoading } from "../app/actions";
import generateQuery from "helpers/query";
import { areaStatementSorting } from "constants/sorting";
import { CUSTOM_SETTINGS } from "constants/.";

export const actionTypes = {
  GET_AREA_STATEMENT_REQUEST: "GET_AREA_STATEMENT_REQUEST",
  GET_AREA_STATEMENT_SUCCESS: "GET_AREA_STATEMENT_SUCCESS",
  GET_AREA_STATEMENT_FAILURE: "GET_AREA_STATEMENT_FAILURE",
  OPEN_AREA_STATEMENT_PAGE_SUCCESS: "OPEN_AREA_STATEMENT_PAGE_SUCCESS",
};

export default class Actions {
  public static getAreaStatements(meta: IMeta = {}) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      if (_.isEmpty(meta)) {
        meta = _.get(getState(), "areaStatements.meta", {});
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(savedSettings, `${CUSTOM_SETTINGS.areaStatements}.pageSize`, 10)
        );
      }
      meta.defaultSorting = areaStatementSorting;

      const url = `AreaStatementLines?$select=Id,MijnCNB_Status,DocumentId&$expand=AreaStatement($select=HarvestYear),
      LicenceContractLine($select=Id),LicenceContractLine($expand=LicenceContract($select=Specie, Cultivar)),
      LicenceContractLine($expand=LicenceContract($expand=Licensor($select=Number, Name))),
      Document($select= Id, Url)${generateQuery(
        meta,
        null,
        "MijnCNB_Status eq true"
      )}`;

      try {
        const { data } = await axios.get(url);
        const payload = _.get(data, "value", []);
        const newMeta = {
          ...meta,
          count: +_.get(data, "odata.count", 0),
        };
        dispatch(setLoading(false));
        dispatch(success(payload, newMeta));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_AREA_STATEMENT_REQUEST };
    }
    function success(payload, meta) {
      return { type: actionTypes.GET_AREA_STATEMENT_SUCCESS, payload, meta };
    }
    function failure(error) {
      return { type: actionTypes.GET_AREA_STATEMENT_FAILURE, error };
    }
  }

  public static async getExportData(searchString) {
    const url = `OrdersExtended?$expand=Document,OtherRelation,Supplier,Seller,
      BuyerAgent,SellerAgent,Lines/QuantityUnit,Lines/Item,Lines/Item/ProductType,
      Lines/Item/ProductType/ProductGroup,Lines/Item/ProductType/ProductGroup/ProductCategory,
      Lines/ProductValue1,Lines/ProductValue2,Lines/ProductValue3,Lines/PriceUnit
      &$select=Id,Document/Id,Document/Url,Number,VersionNumber,StateId,RoleId,
      TypeId,Date,DeliveryPeriodStart,OtherRelation/Name,OtherRelation/Number,
      PaymentDateArrangementTypeId,DateModified,ExternalReferenceNumber,HarvestYear,
      TotalAmount,PaymentDate,AdvancePayment,InCoverScheme,DeliveryPeriodEnd,
      Supplier/Name,Seller/Name,BuyerAgent/Name,SellerAgent/Name,Lines/Number,
      Lines/Item/ProductType/ProductGroup/ProductCategory/Description,Lines/ProductValue1/Description,
      Lines/ProductValue2/Description,Lines/ProductValue3/Description,Lines/Price,
      Lines/PriceUnit/Description,Lines/Quantity,Lines/QuantityUnit/Description,
      Lines/ShippedQuantity,Lines/ShippedCompletely,Lines/OrderedAmount,Lines/Bio,
      Lines/GrowerClaims,Lines/Item/ProductType/ProductGroup/Description,
      Lines/Item/ProductType/Description,Lines/Item/Description,Lines/Item/CultivarDescription
      ${generateQuery({ searchString, findAll: true }, "(RelationId")})
      &$orderby=Date asc, Number asc`;

    try {
      const {
        data: { value },
      } = await axios.get(url);
      return value;
    } catch (error) {
      return error;
    }
  }
}
